<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Horizontal Space</span>
    <div class="wf-w-1/2">
      <vue-slider
        ref="space-horizontal-slider"
        v-model="spaceHorizontal"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="spaceHorizontalClasses"
      ></vue-slider>
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  import { SpaceHorizontalClasses } from '../classes/SpaceClasses'
  export default MenuStyleProperty.extend({
    computed: {
      spaceHorizontalClasses() {
        return Object.keys(SpaceHorizontalClasses)
      },
      spaceHorizontal: {
        get() {
          let currentSpaceHorizontal = this.elementClasses(this.classes)[this.device].find(elementClass => this.spaceHorizontalClasses.includes(elementClass.value))
          if (! currentSpaceHorizontal) {
            currentSpaceHorizontal = {property: 'SpaceHorizontal', value: 'SPACE_XS', touched: false}
            this.addToArray(this.module, [currentSpaceHorizontal], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentSpaceHorizontal.value
        },
        set: _.debounce(function (value) {
          let currentSpaceHorizontal = this.elementClasses(this.classes)[this.device].find(elementClass => this.spaceHorizontalClasses.includes(elementClass.value))
          value = {property: 'SpaceHorizontal', value: value, touched: currentSpaceHorizontal.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>